import React, { ComponentType, ReactNode } from 'react'

/**
 * Checks if React children contain a specific component type, even deeply nested.
 */
export function hasChildOfType<T>(children: ReactNode, component: ComponentType<T>): boolean {
  let found = false

  React.Children.forEach(children, child => {
    if (!React.isValidElement(child)) return

    if (isSameComponentType(child.type, component)) {
      found = true
      return
    }

    if (child.props?.children && !found) {
      found = hasChildOfType(child.props.children, component)
    }
  })

  return found
}

/**
 * Determines if a React element type matches a given component,
 * accounting for memo, forwardRef, and HOCs.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isSameComponentType<T>(type: any, component: ComponentType<T>): boolean {
  return (
    type === component ||
    type?.type === component || // React.memo, forwardRef
    type?.render === component || // Possible for some HOCs
    (type?.displayName && type?.displayName === component.displayName)
  )
}
